import { gql } from '@apollo/client';
import KEY_TEACHER_CREATED_ACTIVITY from '../fragments/keyboarding-teacher-created-activity';

const KEYBOARDING_ENRICHMENT_SETTING = gql`
  fragment BaseKeyEnrichmentActivitySettings on KeyEnrichmentActivitySettings {
    hearItTypeIt {
      enabled
    }
    myChoiceKeyboarding {
      enabled
    }
    teacherCreated {
      enabled
      activities {
        ...BaseKeyTeacherCreatedActivity
      }
    }
  }
  ${KEY_TEACHER_CREATED_ACTIVITY}
`;

export default KEYBOARDING_ENRICHMENT_SETTING;
